import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "my-10" }
const _hoisted_2 = { class: "container-fluid my-10 px-5" }
const _hoisted_3 = { class: "row mt-2" }

import ListTop from "./sections/ListTop.vue";
import ClassCardItem from "./sections/ClassCardItem.vue";
import NoDataSection from "../list/section/NoDataSection.vue";
import NotFoundDataSection from "../list/section/NotFoundDataSection.vue";
import DialogContainer from "../../components/dialog/DialogsContainer.vue";
import { translation } from "../../lang/Translation";
import { ClassMemberContainsLoader } from "./logics/ClassMemberContainsLoader";

export default /*#__PURE__*/_defineComponent({
  __name: 'ClassMemberContainsListPage',
  setup(__props) {

const t = translation;
const loader = new ClassMemberContainsLoader();
loader.load().then();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DialogContainer),
    _createVNode(ListTop, {
      style: {"background-color":"white"},
      class: "sticky-top px-5 pb-1",
      title: _unref(t).to('クラスメンバー作品リスト', 'class_member_project_list'),
      "current-page": _unref(loader).currentPage.value,
      rows: _unref(loader).fullList.value,
      "page-size": _unref(loader).dispSize.value,
      "on-page-changed": _unref(loader).pageChanged,
      "on-add-new": _unref(loader).addNew,
      "on-filter": _unref(loader).filter
    }, null, 8, ["title", "current-page", "rows", "page-size", "on-page-changed", "on-add-new", "on-filter"]),
    (_unref(loader).ownedAllList.value.length === 0)
      ? (_openBlock(), _createBlock(NoDataSection, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(loader).ownedAllList.value.length > 0 && _unref(loader).fullList.value.length === 0)
      ? (_openBlock(), _createBlock(NotFoundDataSection, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(loader).dispList.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.user_block_contents_id,
            class: "col-xs-6 col-3 gy-3"
          }, [
            _createVNode(ClassCardItem, {
              item: item,
              class: _normalizeClass({ added: _unref(loader).newProjectId.value === item.project_id }),
              "on-reload": _unref(loader).load
            }, null, 8, ["item", "class", "on-reload"])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})